import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconClockUser';
/** Renders an SVG icon. */
const SvgClockUser = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M13.995 27.794A4 4 0 0 0 10 24H8a4 4 0 0 0-4 4h10zM16 28a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2 6 6 0 0 1 6-6h2a6 6 0 0 1 6 6"
      />
      <path fill="currentColor" d="M11 20a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0" />
      <path
        fill="currentColor"
        d="M17.713 2.105a14 14 0 0 0-15.578 11.96 1 1 0 1 0 1.98.276 12 12 0 1 1 16.862 12.578 1 1 0 0 0 .83 1.82 14 14 0 0 0-4.094-26.634"
      />
      <path
        fill="currentColor"
        d="M14.875 7a1.125 1.125 0 0 1 2.25 0v7.875H21a1.125 1.125 0 0 1 0 2.25h-5A1.125 1.125 0 0 1 14.875 16z"
      />
    </svg>
  );
};
SvgClockUser.displayName = displayName;
export default SvgClockUser;
